import { useTheme } from '@mui/material';
import { uniq } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  EmployeeCalendarEvent,
  EmployeeCalendarEventLegend,
} from '~/components/EmployeeCalendar';
import { absenceEventColors } from '~/components/EmployeeCalendar/Absences/data';

type PropsType = {
  events: EmployeeCalendarEvent[];
};

export const useLimitedAbsenceCalendarLegend = (props: PropsType) => {
  const { events } = props;

  const { t } = useTranslation();

  const theme = useTheme();

  const eventColorLegends: EmployeeCalendarEventLegend[] = useMemo(() => {
    const colorLegends = [
      {
        key: 'VACATION',
        content: '',
        label: t('laVacation'),
        colors: {
          backgroundColor: absenceEventColors.HOLIDAY_GREEN,
          color: theme.palette.common.white,
        },
      },
      {
        key: 'OTHER',
        content: '',
        label: t('laOther'),
        colors: {
          backgroundColor: absenceEventColors.OTHER,
          color: theme.palette.common.white,
        },
      },
    ];
    const eventCodes = uniq(events.map((event) => event.eventCode));

    return colorLegends.filter((legend) => eventCodes.includes(legend.key));
  }, [t, theme, events]);

  const getAbsenceLegend = useCallback(
    (event: EmployeeCalendarEvent): EmployeeCalendarEventLegend | undefined => {
      return eventColorLegends.find((legend) => legend.key === event.eventCode);
    },
    [eventColorLegends],
  );

  return {
    eventColorLegends,
    getAbsenceLegend,
  };
};
